'use strict';

var d3 = require('d3');
var ChartFbcApplicabilityViewport = function ChartFbcApplicabilityViewport(AbstractChart, chartGroups, chartBelts, chartScales, chartBrush, chartXAxis, viewportService) {
  var chartParams = require('./ParamsViewport');
  var Chart = function Chart(container, formatters) {
    AbstractChart.call(this, container);
    var groups = chartGroups('startDate', undefined, true);
    var belts = chartBelts('startDate', 'endDate', 'fareValue', 'fares');
    var tickValues = [];
    var xAxis = chartXAxis(formatters.xAxisTickViewportFormatter, tickValues);
    var maxBrushSelection = 0;
    var dispatch = d3.dispatch('rangechange');
    d3.rebind(this, dispatch, 'on');
    var brush = chartBrush();
    function getSelectionRange(selectionSize, domainLength) {
      if (selectionSize > 0) {
        return [0, Math.min(selectionSize, domainLength)];
      } else {
        return [Math.max(0, domainLength + selectionSize), domainLength];
      }
    }
    function updateBrushSelection(selectionSize, domainLength) {
      var initializingChart = selectionSize !== undefined;
      var resizingChart = selectionSize === undefined;
      if (initializingChart) {
        brush.setSelection(getSelectionRange(selectionSize, domainLength));
      }
      if (resizingChart) {
        brush.setSelection(brush.getSelection());
      }
    }
    this.render = function (data, xAxisValues, selectionSize) {
      var range = [0, xAxisValues.length];
      maxBrushSelection = selectionSize;
      var xAxisTickValues = viewportService.calculateTickValues(xAxisValues);
      formatters.xAxisTickViewportFormatter.setVisibleTickValues(xAxisTickValues.ticksVisibleValues);
      brush.withSizeRange({
        max: maxBrushSelection
      });
      tickValues.splice(0, tickValues.length);
      tickValues.push.apply(tickValues, xAxisTickValues.tickValues);
      this.initChart(data, range, chartParams);
      this.scales = chartScales(this.params, data, xAxisValues, range);
      this.callForDataGroup([groups, belts, xAxis]);
      this.callForPostDataGroup([brush.withDomainRange(this.visibleXRange)], this.scales);
      updateBrushSelection(maxBrushSelection, this.scales.xScale.domain().length);
    };
    brush.on('brushchange', function (range) {
      dispatch.rangechange(range);
    });
    this.resetBrushSelection = function () {
      updateBrushSelection(maxBrushSelection, this.scales.xScale.domain().length);
    };
  };
  Chart.prototype = Object.create(AbstractChart.prototype);
  Chart.constructor = Chart;
  return Chart;
};
ChartFbcApplicabilityViewport.$inject = ['AbstractChart', 'ChartElementsGroup', 'ChartElementsBelts', 'ChartFBCApplicabilityScalesFactory', 'ChartElementsBrush', 'ChartElementsXAxis', 'ChartFbcApplicabilityViewportService'];
module.exports = ChartFbcApplicabilityViewport;